import React, { useLayoutEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import FoodOrderItemCard from "./FoodOrderItemCard"
import FoodComboCard from "./FoodComboCard"
import { AddFoodPageSidebarRef } from "@redux"
import { isConvertibleToBuyXFreeX } from "utils"
import classes from "./index.module.scss"

const FoodSidebarOrderDetails = () => {
  const dispatch = useDispatch()

  const orderItems =
    useSelector(state => state.order.items)

  const orderCombos =
    useSelector(state => state.order.combos)

  useLayoutEffect(() => {
    isConvertibleToBuyXFreeX()
  }, [orderItems])

  const sortOrderContents = () => {
    const orderCombosWithIndex =
      orderCombos.map((oc, orderComboIndex) => ({
        ...oc,
        orderComboIndex
      }))

    const contents = [
      ...orderItems,
      ...orderCombosWithIndex
    ]

    const sortedContents =
      contents.sort((a, b) => (
        a.sortNumber > b.sortNumber ? 1 : -1
      ))

    return sortedContents
  }

  const orderContents = sortOrderContents()

  return (
    <div
      className={classes["container"]}
      ref={ref =>
        dispatch(AddFoodPageSidebarRef(ref))
      }
    >
      {orderContents.map(content =>
        isNaN(content.comboSetSalePrice)
          ?
          <FoodOrderItemCard
            key={content.orderItemId}
            orderItem={content}
          />
          :
          <FoodComboCard
            key={content.orderComboIndex}
            orderCombo={content}
            orderComboIndex={content.orderComboIndex}
          />
      )}
    </div>
  )
}

export default React.memo(FoodSidebarOrderDetails)